// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1-Q2H","label":"Completed_label__3KLLX"};